<tui-tabs
  [activeItemIndex]="activeTab() === 'users' ? 0 : 1"
  (activeItemIndexChange)="tabChange.emit($event === 0 ? 'users' : 'roles')"
>
  <button tuiTab type="button">Users</button>
  <button tuiTab type="button">Roles and permissions</button>
</tui-tabs>

@if (activeTab() === 'users') {
  <app-settings-user-list (add)="addUser.emit()" (edit)="editUser.emit($event)" />
} @else {
  <app-settings-role-list
    (add)="addRole.emit()"
    (edit)="editRole.emit($event)"
    (copy)="copyRole.emit($event)"
  />
}
